import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const textareaVariants = cva(
  'min-h-28 w-full resize-y rounded-md border border-border-subtle bg-surface-input px-3 py-2 text-base font-sans font-normal leading-[1.5] text-fg-primary placeholder:text-fg-secondary placeholder:opacity-75 [border-color:var(--input-border-color,var(--color-border-subtle))] [background-color:var(--input-bg,var(--color-surface-input))] [color:var(--input-fg,var(--color-fg-primary))] placeholder:[color:var(--input-placeholder,var(--color-fg-secondary))] transition-[border-color,box-shadow] duration-150 ease-in-out focus-visible:[border-color:var(--input-focus-border,var(--color-ring-default))] focus-visible:outline-none focus-visible:ring-2 focus-visible:[box-shadow:0_0_0_2px_var(--input-focus-ring,var(--color-ring-default))] disabled:cursor-not-allowed disabled:opacity-60',
  {
    variants: {
      context: {
        default: '',
        modal:
          '![--input-border-color:var(--color-neutral-0-10)] !bg-[var(--surface-tint-inverse)] !text-[var(--color-modal-fg)] !placeholder:text-[var(--color-modal-fg)] !focus-visible:border-[var(--color-modal-fg)] !focus-visible:ring-0',
      },
      focusRing: {
        default: '',
        none: 'focus-visible:border-border-subtle focus-visible:ring-0',
      },
      state: {
        default: '',
        error:
          'border-status-danger focus-visible:border-status-danger focus-visible:ring-[var(--color-ring-danger)]',
      },
    },
    defaultVariants: {
      context: 'default',
      focusRing: 'default',
      state: 'default',
    },
  }
);

type TextareaProps = React.ComponentProps<'textarea'> &
  VariantProps<typeof textareaVariants>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, context, focusRing, state, ...props }, ref) => {
    return (
      <textarea
        data-slot="textarea"
        ref={ref}
        data-context={context}
        className={cn(
          textareaVariants({ context, focusRing, state }),
          className
        )}
        {...props}
      />
    );
  }
);

Textarea.displayName = 'Textarea';

export { Textarea };
